import { render, staticRenderFns } from "./SubLessons.vue?vue&type=template&id=27c0860b"
import script from "./SubLessons.vue?vue&type=script&lang=js"
export * from "./SubLessons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports